import type { FileObjectType } from "@jsq/ds/core";
import { validateEmail } from "~/pages/DataStudio/utils/validation";
import { MAX_FILE_SIZE } from "../constants";

export { validateEmail };

export function validateFiles(files: FileObjectType[]): {
  isValid: boolean;
  errorMessage?: string;
} {
  if (files.length === 0) {
    return {
      isValid: false,
      errorMessage: "Please select a file to upload",
    };
  }

  // Validate file types - accept only TSV
  const invalidFiles = files.filter((fileObj) => {
    const file = fileObj.file;
    if (!file) return true;
    const fileName = file.name.toLowerCase();
    return !fileName.endsWith(".tsv");
  });

  if (invalidFiles.length > 0) {
    return {
      isValid: false,
      errorMessage: "Only TSV files are allowed. Please select a valid file.",
    };
  }

  // Validate file size
  const oversizedFiles = files.filter((fileObj) => {
    const file = fileObj.file;
    return file && file.size > MAX_FILE_SIZE;
  });

  if (oversizedFiles.length > 0) {
    return {
      isValid: false,
      errorMessage: "File size must be less than 10MB. Please select a smaller file.",
    };
  }

  return { isValid: true };
}
